import React from "react";
import { KidhLogo } from "./Logo";
import { Linkedin, Facebook } from "lucide-react";

const WAYNE_LOGO =
  "https://customer-assets.emergentagent.com/job_vision-landing-7/artifacts/4ey5wr9k_Logo_Holding_OS_-_61.png";

const PARTNERS = [
  { name: "Wayne Côte d'Ivoire", tag: "By Kip Energy · Multiservices", logo: WAYNE_LOGO },
  { name: "Beachcomber Hotels", tag: "Hospitality · Sassandra" },
  { name: "Zebra Technologies", tag: "IoT · EKIPTECH" },
  { name: "IFC / Proparco", tag: "DFI" },
  { name: "BOAD", tag: "Banque Ouest-Africaine" },
  { name: "SIB", tag: "Banque partenaire" },
  { name: "SGBCI", tag: "Banque partenaire" },
  { name: "BSIC", tag: "Banque partenaire" },
];

const Footer = () => {
  const partnersDouble = [...PARTNERS, ...PARTNERS];

  return (
    <footer data-testid="site-footer" className="bg-[#0C2340] text-white">
      {/* Partners marquee strip */}
      <div className="border-t border-b border-white/10 overflow-hidden py-8">
        <div className="flex items-center gap-2 px-6 md:px-16 mb-6">
          <span className="kidh-diamond" />
          <span className="font-body text-[0.65rem] uppercase tracking-[0.32em] text-white/50">
            Ils construisent avec nous
          </span>
        </div>
        <div className="relative overflow-hidden">
          <div className="kidh-marquee-track flex gap-16 whitespace-nowrap w-max">
            {partnersDouble.map((p, i) => (
              <div key={`${p.name}-${i}`} className="flex flex-col justify-center min-w-[220px] px-6 border-l border-white/10">
                {p.logo ? (
                  <img
                    src={p.logo}
                    alt={p.name}
                    className="h-12 w-auto object-contain object-left opacity-90 hover:opacity-100 transition-opacity"
                    style={{ background: "#FAFAF8", padding: "6px 10px" }}
                  />
                ) : (
                  <span className="font-heading font-bold text-white text-lg tracking-tight">
                    {p.name}
                  </span>
                )}
                <span className="font-body text-[0.6rem] uppercase tracking-[0.28em] text-white/40 mt-1">
                  {p.tag}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Main footer */}
      <div className="max-w-[1400px] mx-auto px-6 md:px-16 py-16 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-5">
            <KidhLogo inverse useImage />
            <p className="mt-8 font-heading font-black text-white text-3xl md:text-5xl tracking-tighter leading-none max-w-md">
              Ensemble,<br />
              <span className="text-[#E8611A]">Vivons Mieux.</span>
            </p>
            <p className="mt-8 font-body text-white/60 text-sm max-w-md leading-relaxed">
              KIDH — Kipyz Design & Houses SA · Une filiale d'EKIP Holding Company.
              L'écosystème intégré de la vie moderne en Afrique de l'Ouest.
            </p>
          </div>

          <div className="md:col-span-2">
            <div className="font-body text-[0.65rem] uppercase tracking-[0.28em] text-white/50 mb-4">
              Naviguer
            </div>
            <ul className="space-y-3 font-body text-sm text-white/80">
              <li><a href="#philosophie" className="hover:text-[#E8611A]">Philosophie</a></li>
              <li><a href="#vision" className="hover:text-[#E8611A]">Vision 2035</a></li>
              <li><a href="#poles" className="hover:text-[#E8611A]">Nos pôles</a></li>
              <li><a href="#projets" className="hover:text-[#E8611A]">Projets phare</a></li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <div className="font-body text-[0.65rem] uppercase tracking-[0.28em] text-white/50 mb-4">
              Écosystème
            </div>
            <ul className="space-y-3 font-body text-sm text-white/80">
              <li>Kip Energy</li>
              <li>EKIPTECH</li>
              <li>KIPAY</li>
              <li>EKIP Capital</li>
            </ul>
          </div>

          <div className="md:col-span-3">
            <div className="font-body text-[0.65rem] uppercase tracking-[0.28em] text-white/50 mb-4">
              Contact
            </div>
            <ul className="space-y-3 font-body text-sm text-white/80">
              <li>RCI - Abidjan, Cocody 2 Plateaux</li>
              <li><a href="mailto:contact@kidh.ci" className="hover:text-[#E8611A]">contact@kidh.ci</a></li>
              <li><a href="tel:+2252722010120" className="hover:text-[#E8611A]">+225 27 22 01 01 20</a></li>
              <li><a href="tel:+22505555511462" className="hover:text-[#E8611A]">+225 05 55 511 462</a></li>
            </ul>
            <div className="flex gap-4 mt-6">
              {[
                { Icon: Linkedin, href: "https://www.linkedin.com/company/kidhci", label: "LinkedIn" },
                { Icon: Facebook, href: "https://www.facebook.com/KidhRealestate/", label: "Facebook" },
              ].map(({ Icon, href, label }, i) => (
                <a
                  key={i}
                  href={href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 border border-white/15 flex items-center justify-center hover:bg-[#E8611A] hover:border-[#E8611A] transition-colors"
                  aria-label={label}
                  data-testid={`social-${i}`}
                >
                  <Icon size={16} strokeWidth={1.4} />
                </a>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col md:flex-row items-start md:items-center justify-between gap-4 text-white/40 font-body text-xs">
          <div>© 2026 KIDH — Kipyz Design & Houses SA · Tous droits réservés</div>
          <div className="flex flex-wrap gap-6">
            <span>Mentions légales</span>
            <span>Confidentialité</span>
            <span>Cookies</span>
            <span>CNPC-CI · Agrément</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
